var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBill = function SvgBill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.764 0A.75.75 0 0 0 0 .75v15.5C0 17.76 1.24 19 2.75 19h10.5c1.51 0 2.75-1.24 2.75-2.75V.75a.75.75 0 0 0-1.055-.686l-1.96.872-2.207-.882a.75.75 0 0 0-.556 0L8 .942 5.778.054a.75.75 0 0 0-.556 0L3.016.936 1.055.064A.75.75 0 0 0 .764 0ZM3.25 6h9.5a.749.749 0 1 1 0 1.5h-9.5a.749.749 0 1 1 0-1.5Zm0 4.5h5.5a.749.749 0 1 1 0 1.5h-5.5a.749.749 0 1 1 0-1.5Zm8.5 0h1a.749.749 0 1 1 0 1.5h-1a.749.749 0 1 1 0-1.5Zm-8.5 3h5.5a.749.749 0 1 1 0 1.5h-5.5a.749.749 0 1 1 0-1.5Zm8.5 0h1a.749.749 0 1 1 0 1.5h-1a.749.749 0 1 1 0-1.5Z",
    fill: "gray"
  })));
};

export default SvgBill;